module.exports = __webpack_public_path__ + "static/media/2DGACM14.9e4d81fa.jpg";